import { Spinner } from "@bigbinary/neeto-atoms";
import { useTranslation } from "react-i18next";

import ProductLink from "./ProductLink";

const Content = ({ highlightedIndex, filteredApps, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner data-testid="neeto-ui-spinner" />
      </div>
    );
  }

  return filteredApps?.length > 0 ? (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(288px,1fr))] gap-3 max-lg:grid-cols-[repeat(auto-fill,minmax(248px,1fr))] max-sm:grid-cols-1">
      {filteredApps.map((app, index) => (
        <ProductLink
          key={app.name}
          {...app}
          data-highlighted-index={index}
          isHighlighted={index === highlightedIndex}
        />
      ))}
    </div>
  ) : (
    <p className="text-center text-sm" data-testid="no-apps-found-title">
      {t("neetoMolecules.productSwitcher.noApps")}
    </p>
  );
};

export default Content;
